import { BOARD_WIDTH, BOARD_HEIGHT } from './constants';

// 创建空游戏板
export const createEmptyBoard = () => {
  return Array(BOARD_HEIGHT).fill().map(() => Array(BOARD_WIDTH).fill(0));
};

// 检查碰撞
export const checkCollision = (board, tetromino, position) => {
  const { shape, x, y } = tetromino;
  
  for (let row = 0; row < shape.length; row++) {
    for (let col = 0; col < shape[row].length; col++) {
      // 如果是方块的一部分
      if (shape[row][col] !== 0) {
        const boardX = x + col;
        const boardY = y + row;
        
        // 检查是否超出边界或与其他方块重叠
        if (
          boardX < 0 || 
          boardX >= BOARD_WIDTH ||
          boardY >= BOARD_HEIGHT ||
          (boardY >= 0 && board[boardY][boardX] !== 0)
        ) {
          return true;
        }
      }
    }
  }
  
  return false;
};

// 合并方块到游戏板
export const mergeTetrominoWithBoard = (board, tetromino) => {
  const { shape, x, y, colorIndex } = tetromino;
  const newBoard = JSON.parse(JSON.stringify(board));
  
  for (let row = 0; row < shape.length; row++) {
    for (let col = 0; col < shape[row].length; col++) {
      if (shape[row][col] !== 0) {
        const boardY = y + row;
        if (boardY >= 0) { // 只在可见区域合并方块
          newBoard[boardY][x + col] = colorIndex + 1; // +1 因为颜色索引从0开始，而0表示空白
        }
      }
    }
  }
  
  return newBoard;
};

// 旋转方块
export const rotateShape = (shape) => {
  // 转置矩阵
  const transposed = shape.map((_, index) => 
    shape.map(row => row[index])
  );
  
  // 每行反转（相当于顺时针旋转90度）
  return transposed.map(row => [...row].reverse());
};

// 检查并清除已填满的行
export const clearCompletedRows = (board) => {
  let clearedRows = 0;
  const newBoard = board.filter(row => {
    const isRowComplete = row.every(cell => cell !== 0);
    if (isRowComplete) clearedRows++;
    return !isRowComplete;
  });
  
  // 在顶部添加新的空行
  while (newBoard.length < BOARD_HEIGHT) {
    newBoard.unshift(Array(BOARD_WIDTH).fill(0));
  }
  
  return { newBoard, clearedRows };
};

// 计算分数
export const calculateScore = (clearedRows, level) => {
  // 根据经典俄罗斯方块的得分规则
  const pointsPerLine = [0, 40, 100, 300, 1200];
  return pointsPerLine[clearedRows] * level;
};